import { FormItem } from '@framework/form/item/FormItem.tsx';
import { Card } from 'antd';
import { type IReference } from '../../../../../expressions/references/IReference.ts';
import { type IAsyncService } from '../../../../../expressions/repository/async/context/IAsyncService.ts';
import { AsyncServiceInputsInput } from '../../../../../expressions/repository/async/input/AsyncServiceInputsInput.tsx';

export interface IAsyncServiceInputConfigFormProps {
  name: string;
  service: IAsyncService;
  references: IReference[];
  /** e.g. Disabilito l'input già selezionato come filtro di ricerca */
  disableInput?: (input: string) => boolean;
}

/**
 * Form che permette di configurare gli input da passare ad un servizio asincrono.
 * Permette di configurare come i valori del form compilati dall'utente vengano
 * forniti come parametri della chiamata al servizio in fase di compilazione.
 */
export function AsyncServiceInputConfigForm(
  props: IAsyncServiceInputConfigFormProps,
) {
  const { name, service, references, disableInput } = props;
  return (
    <div style={{ paddingTop: '8px' }}>
      <Card size="small" title="Configura Parametri">
        <div style={{ marginBottom: '8px' }}>
          <FormItem name={name} layout={{ removeHelpMargin: true }}>
            <AsyncServiceInputsInput
              style={{ minWidth: '200px', width: '100%' }}
              name="inputs"
              service={service}
              references={references}
              size="large"
              disableInput={disableInput}
            />
          </FormItem>
        </div>
      </Card>
    </div>
  );
}
